import type { Country, CurrencyCode } from '../../types';
import { MOCK_COUNTRIES } from '../../lib/mockData';
import { request } from '../api/client';

export const internationalService = {
  listCountries() {
    return request('/intl/countries', () => MOCK_COUNTRIES);
  },

  getCountry(code: string) {
    return request(`/intl/countries/${code}`, () => MOCK_COUNTRIES.find((c) => c.code === code));
  },

  /** Cross-border fee estimate (correspondent + FX margin + SWIFT). */
  estimateFees(amount: number, country: Country) {
    return request('/intl/fees', () => {
      const fxMargin = Math.round(amount * 0.008 * 100) / 100;
      const swift = country.swift ? 18 : 0;
      const correspondent = 12;
      return { fxMargin, swift, correspondent, total: fxMargin + swift + correspondent };
    }, { delay: 220 });
  },

  track(reference: string) {
    return request('/intl/track', () => ({
      reference,
      steps: [
        { label: 'Payment initiated', done: true, at: 'Today, 09:14' },
        { label: 'Compliance cleared', done: true, at: 'Today, 09:16' },
        { label: 'Sent to correspondent bank', done: true, at: 'Today, 09:40' },
        { label: 'In transit (SWIFT network)', done: false, at: 'Est. 1-2 business days' },
        { label: 'Credited to recipient', done: false, at: 'Pending' },
      ],
    }));
  },

  supportedCurrencies(): CurrencyCode[] {
    return MOCK_COUNTRIES.filter((c) => c.supported).map((c) => c.currency);
  },
};
